var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkill19(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.318 32.318",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.806,425.715a14.979,14.979,0,1,1-14.978,14.979,14.978,14.978,0,0,1,14.978-14.979m0,31.138a16.159,16.159,0,1,0-16.159-16.159h0a16.178,16.178,0,0,0,16.159,16.159",
    transform: "translate(-550.647 -424.534)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.746 2.747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.355,444.262a1.753,1.753,0,0,1-1.227-2.914l-1.354-1.354a3.658,3.658,0,0,0,.011,5.026l1-.842-.842.994a3.658,3.658,0,0,0,2.416,1Z",
    transform: "translate(-555.046 -429.09)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.272,447.691a4.4,4.4,0,0,1-2.9-1.18l-1.3,1.536a6.406,6.406,0,0,0,4.2,1.66Z",
    transform: "translate(-554.963 -429.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.27,437.2a6.406,6.406,0,0,0-4.181-1.658v2.019a4.407,4.407,0,0,1,2.879,1.179Z",
    transform: "translate(-555.55 -428.569)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.847,445.856a4.406,4.406,0,0,1-1.179-2.9h-2.013a6.409,6.409,0,0,0,1.658,4.2Z",
    transform: "translate(-554.68 -429.437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.108,439.666l1.354,1.349a1.766,1.766,0,1,1,1.257,3.091v1.914a3.666,3.666,0,0,0,2.415-1l-.842-.994.994.842a3.66,3.66,0,0,0,0-5.039l-.994.842.841-.994a3.657,3.657,0,0,0-5.025-.012Z",
    transform: "translate(-555.201 -428.935)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.123,431.665a9.346,9.346,0,0,0-6.212,2.366l3.207,3.785A4.406,4.406,0,0,1,568,436.636v-2.147h.125v-.125a6.654,6.654,0,0,1,4.469,1.724l1.589-1.875a8.955,8.955,0,0,0-1.052-.807l.549-.84a10.186,10.186,0,0,1,1.148.883l2.111-2.493a13.362,13.362,0,0,0-8.565-3.3v3.763h-.25Z",
    transform: "translate(-554.71 -427.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.065,449.708a6.412,6.412,0,0,0,4.2-1.66l-1.3-1.536a4.41,4.41,0,0,1-2.9,1.18Z",
    transform: "translate(-555.547 -429.852)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.206,444.789l.252-.049a9.87,9.87,0,0,1-.181-1.779h-3.52a13.356,13.356,0,0,0,3.306,8.707l2.486-2.106A10.123,10.123,0,0,1,557.206,444.789Z",
    transform: "translate(-553.756 -429.437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.457,439.008l-3.785-3.207a9.348,9.348,0,0,0-2.358,6.1h4.965A4.4,4.4,0,0,1,564.457,439.008Z",
    transform: "translate(-554.289 -428.599)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.035,441.73h1.509a9.84,9.84,0,0,1,2.479-6.426l-1.161-.982A11.386,11.386,0,0,0,556.035,441.73Z",
    transform: "translate(-554.023 -428.426)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.039,452.885v-2.7a6.667,6.667,0,0,1-4.366-1.717l-1.595,1.883a9.111,9.111,0,0,0,4.22,2.1l-.049.245A9.433,9.433,0,0,0,568.039,452.885Z",
    transform: "translate(-554.73 -430.081)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.957,427.645",
    transform: "translate(-555.534 -427.645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.71,432.852l-2.491,2.11a10.122,10.122,0,0,1,2.534,6.706h-1a9.121,9.121,0,0,0-2.3-6.058L574.58,437.2a6.654,6.654,0,0,1,0,8.937l5.132,4.348a13.4,13.4,0,0,0,0-17.633Z",
    transform: "translate(-556.192 -428.254)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.756,442.827",
    transform: "translate(-553.756 -429.421)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.5,451.24a9.933,9.933,0,0,1-6.439,2.472v3.52a13.366,13.366,0,0,0,8.712-3.306Z",
    transform: "translate(-555.547 -430.405)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.674,453.736a9.842,9.842,0,0,1-1.89-.2l-.051.247a10.131,10.131,0,0,1-4.668-2.32l-2.1,2.482a13.628,13.628,0,0,0,1.127.883l.02.014c.088.06.172.118.26.177l.035.024.249.16.046.028c.08.051.162.1.243.148l.055.032c.079.048.161.094.242.14l.057.031.246.132.057.03c.088.044.169.088.254.129l.051.026c.088.044.181.088.273.128l.038.018c.1.048.206.094.31.138h0q.479.2.978.372l.055.018c.088.03.177.059.27.088l.094.027c.079.024.156.048.235.069l.115.031.218.058.127.031.208.049.135.03.2.042.141.027c.066.013.134.025.2.037l.145.024.2.03.147.021.2.025.148.017.208.02.146.013.217.014.138.01.24.01.117,0h.256Z",
    transform: "translate(-554.365 -430.432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.961,430.954l1.077,1.272a11.708,11.708,0,0,1,1.127-.874l.193.282a11.043,11.043,0,0,0-1.1.853l.985,1.161a9.833,9.833,0,0,1,6.284-2.472v-3.524A13.36,13.36,0,0,0,558.961,430.954Z",
    transform: "translate(-554.365 -427.646)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.43,448.468a6.665,6.665,0,0,1-4.365,1.717v2.7a9.425,9.425,0,0,0,6.114-2.352Z",
    transform: "translate(-555.547 -430.081)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.729,447.32a6.655,6.655,0,0,1-1.717-4.359h-2.7a9.234,9.234,0,0,0,.17,1.685l.24-.048a9.129,9.129,0,0,0,2.124,4.316Z",
    transform: "translate(-554.289 -429.437)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.157,437.958l-1.536,1.3a4.4,4.4,0,0,1,0,6.011l1.536,1.3a6.406,6.406,0,0,0,0-8.615Z",
    transform: "translate(-555.963 -428.851)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.766,
    cy: 0.766,
    rx: 0.766,
    ry: 0.766,
    transform: "translate(12.648 12.648)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.424,441.559a11.744,11.744,0,0,1,2.914-7.629l-1.272-1.077a13.35,13.35,0,0,0-3.306,8.707Z",
    transform: "translate(-553.756 -428.254)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill19);
export default __webpack_public_path__ + "static/media/skill19.9514195f.svg";
export { ForwardRef as ReactComponent };